export default __webpack_public_path__ + "static/media/edunext.alt.6c7bd5f5.png";